module.exports = __webpack_public_path__ + "static/media/talao-exemplo-senha.e190afba.png";